import {isNotNil} from 'ramda';

import {browserStorageKey} from '../constants/browserStorageKey';

const isDev = process.env.ENV_TYPE === 'dev';

function isBrowserStorageAvailable() {
  return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
}

export function hasMandatoryFieldsValidationOverride(): boolean {
  if (!isBrowserStorageAvailable()) {
    return false;
  }

  return isNotNil(localStorage.getItem(browserStorageKey.DISABLE_MANDATORY_FIELDS_VALIDATION));
}

/**
 * Determines if mandatory fields validation should be disabled.
 * Only works in development environments when:
 * 1. We're in development (ENV_TYPE === 'dev')
 * 2. The localStorage flag is set
 */
export function shouldDisableMandatoryFields(): boolean {
  if (!isDev) {
    return false;
  }

  return hasMandatoryFieldsValidationOverride();
}
